module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hwforget"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.$t('nav.mmp')))]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('firstlogin.congratulation')))]), _vm._v(" "), _c('p', {
    staticClass: "tipTwo"
  }, [_vm._v(_vm._s(_vm.$t('firstlogin.changePwd')))])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('firstlogin.newPwd'),
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.inputType,
      "id": "pwd"
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPassword", $$v)
      },
      expression: "form.newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pwdIcon",
    class: {
      'open': _vm.inputChange
    },
    on: {
      "click": function($event) {
        return _vm.changeType()
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('firstlogin.rePwd'),
      "prop": "comfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.inputType2,
      "id": "repwd"
    },
    model: {
      value: (_vm.form.comfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "comfirmPassword", $$v)
      },
      expression: "form.comfirmPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pwdIcon",
    class: {
      'open': _vm.inputChange2
    },
    on: {
      "click": function($event) {
        return _vm.changeType2()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    attrs: {
      "id": "confirmBtn"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('form', $event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('firstlogin.confirm')))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-53193770"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/firstlogin/firstlogin.vue
// module id = 918
// module chunks = 0